/**
 * DataSpecialistRouter - Unified Work Queue Routing
 *
 * All legacy routes redirect to the unified work queue:
 * - /queue/data-specialist → /queue
 * - /review-queue → /queue
 * - /issues → /queue
 *
 * Phase 5.3: UNIFIED_WORK_QUEUE is now permanently enabled.
 * Legacy components (DataSpecialistQueue, TransactionReviewQueue, IssueTrackerDashboard) removed.
 */

import { Navigate } from 'react-router-dom';

/**
 * Data Specialist Queue Router
 * Routes /queue/data-specialist to unified queue
 */
export function DataSpecialistQueueRouter() {
  return <Navigate to="/queue" replace />;
}

/**
 * Transaction Review Queue Router
 * Routes /review-queue to unified queue
 */
export function TransactionReviewRouter() {
  return <Navigate to="/queue" replace />;
}

/**
 * Issue Tracker Router
 * Routes /issues to unified queue
 */
export function IssueTrackerRouter() {
  return <Navigate to="/queue" replace />;
}

export default {
  DataSpecialistQueueRouter,
  TransactionReviewRouter,
  IssueTrackerRouter,
};
